import React from "react";
import { Card, Toggle } from "@opendate-app/setlist";

export const checkedFrom = (value) => (value && value.target ? value.target.checked : Boolean(value));

export const ToggleField = ({ id, title, description, checked, onChange }) => (
  <Toggle id={id} label={title} description={description} checked={checked} onChange={(value) => onChange(checkedFrom(value))} />
);

export const FormSection = ({ id, title, description, flush, children }) => (
  <section id={id} className="membership-section" aria-labelledby={`${id}-title`}>
    <Card padding={flush ? "none" : "md"}>
      <div className={`membership-section-body${flush ? " is-flush" : ""}`}>
        <div className="membership-section-head">
          <h2 id={`${id}-title`} className="membership-section-title">
            {title}
          </h2>
          {description ? <p className="membership-hint">{description}</p> : null}
        </div>
        {children}
      </div>
    </Card>
  </section>
);

export const FieldError = ({ children }) => (children ? <p className="membership-field-error">{children}</p> : null);
